import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { User } from '../../models/index'
import { UserService } from '../../services/user.service'
import { Router } from '@angular/router';

import { UserSessionService } from '../../sevices/user-session.service'
import { Subscription } from 'rxjs';
import { WhitelabelConfigStore } from '../../core/config/whitelabel-config.store';
@Component({
    selector: 'app-headerhome',
    templateUrl: './headerhome.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderhomeComponent implements OnInit, OnDestroy {
  isLoggedIn:any;
  user:User;
  api_error:Error;
  loadingStart:boolean = false;
  resMsg:any
  easyLogin:boolean = false;
  mobileOpen = false;
  accountOpen = false;
  private mobileTrigger: HTMLElement | null = null;
  private readonly sessionSubscription: Subscription;

  constructor(
    private users: UserService,
    private sessionService: UserSessionService,
    private router: Router,
    private elementRef: ElementRef<HTMLElement>,
    private changeDetector: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private readonly platformId: object,
    public readonly configStore: WhitelabelConfigStore
  ) {

    this.sessionSubscription = this.sessionService.currentMessage.subscribe(message =>{
      if (!message) {
        return;
      }
      if (message === "nouser") {
        sessionStorage.setItem('isLoggedInEasy','false')
        localStorage.setItem('isLoggedInEasy','false');
        this.isLoggedIn=false;
        this.accountOpen = false;
        this.changeDetector.markForCheck();
        return;
      }else{
        localStorage.setItem('isLoggedInEasy','true');
        localStorage.setItem('userEasy',JSON.stringify(message));
        this.isLoggedIn=true;
        this.user=new User().deserialize(message)
        // this.getUserProfile(this.user);
        sessionStorage.setItem('isLoggedInEasy','true')
        // sessionStorage.setItem('userEasy',JSON.stringify(message));
        this.changeDetector.markForCheck();
        
      }

   
    });

   }

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.isLoggedIn =
      sessionStorage.getItem('isLoggedInEasy') === 'true' ||
      localStorage.getItem('isLoggedInEasy') === 'true';
    this.easyLogin =  this.isLoggedIn
    if(this.isLoggedIn ){
      const storedUser = sessionStorage.getItem('userEasy') || localStorage.getItem('userEasy');
      if (storedUser) {
        try {
          this.user = new User().deserialize(JSON.parse(storedUser));
          this.getUserProfile(this.user);
        } catch {
          this.isLoggedIn = false;
        }
      } else {
        this.isLoggedIn = false;
      }
    }
  }

  get config() {
    return this.configStore.snapshot.config;
  }

  get supportPhoneHref(): string {
    return `tel:${this.config?.site.supportNumber ?? ''}`;
  }

  get supportEmailHref(): string {
    return `mailto:${this.config?.site.supportEmail ?? ''}`;
  }

  get hasMobileApp(): boolean {
    return !!(this.config?.site.appStoreUrl || this.config?.site.iosAppStoreUrl);
  }

  get accountName(): string {
    return [this.user?.first_name, this.user?.last_name].filter(Boolean).join(' ') || 'My account';
  }

  get accountFirstName(): string {
    return this.user?.first_name || 'Account';
  }

  get accountInitials(): string {
    return [this.user?.first_name, this.user?.last_name]
      .filter(Boolean)
      .map(value => String(value).trim().charAt(0).toUpperCase())
      .join('') || 'A';
  }

  get accountIdentifier(): string {
    return this.user?.phone_number || this.user?.email || 'Signed in';
  }

  isActiveRoute(path: string): boolean {
    return this.router.url.split(/[?#]/)[0] === path;
  }

  toggleMobile(event: MouseEvent): void {
    this.mobileTrigger = event.currentTarget as HTMLElement;
    this.accountOpen = false;
    this.mobileOpen ? this.closeMobile(false) : this.openMobile();
  }

  toggleAccount(): void {
    this.accountOpen = !this.accountOpen;
  }

  closeAccount(): void {
    this.accountOpen = false;
  }

  openMobile(): void {
    this.mobileOpen = true;
    document.body.style.overflow = 'hidden';
  }

  closeMobile(restoreFocus = true): void {
    this.mobileOpen = false;
    document.body.style.overflow = '';
    if (restoreFocus) {
      setTimeout(() => this.mobileTrigger?.focus());
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.accountOpen) {
      this.closeAccount();
      return;
    }
    if (this.mobileOpen) {
      this.closeMobile();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (
      this.accountOpen &&
      !this.elementRef.nativeElement.contains(event.target as Node)
    ) {
      this.closeAccount();
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.body.style.overflow = '';
    }
    this.sessionSubscription.unsubscribe();
  }

  logoutUser(){
    localStorage.removeItem("userEasy");
    sessionStorage.removeItem("userEasy");
    this.isLoggedIn=false;
    this.user = null;
    this.accountOpen = false;
    sessionStorage.setItem('isLoggedInEasy','false')
    localStorage.setItem('isLoggedInEasy','false');
    this.router.navigateByUrl('/home')
  }
  getUserProfile(user:any){
    this.users.getProfile(user).subscribe(
      response => {
          this.loadingStart=false;
          this.resMsg=response;
          const profile = {
            ...user,
            ...(this.resMsg.data || {}),
            token: this.resMsg.data?.token || user.token
          };
          this.user = new User().deserialize(profile);
          localStorage.setItem('userEasy', JSON.stringify(profile));
          sessionStorage.setItem('userEasy', JSON.stringify(profile));
          this.changeDetector.markForCheck();
      },
      error => {
        if (error?.status === 401 || error?.status === 403) {
          localStorage.removeItem("userEasy");
          sessionStorage.removeItem("userEasy");
          sessionStorage.setItem('isLoggedInEasy','false')
          localStorage.setItem('isLoggedInEasy','false');
          this.isLoggedIn=false;
          this.accountOpen = false;
          this.changeDetector.markForCheck();
        }
      }
    );
  }

}
